import subtaskFieldUrl from './subtaskField.html';

class SubtaskFieldCtrl {
  constructor(focus) {
    'ngInject';

    Object.assign(this, { focus });
  }

  $onInit() {
    const canAutoFocus = this.hasMultipleSubtasks();
    if (canAutoFocus && this.isLast) {
      this.focus(`subtask-${this.index}`);
    }
  }

  onEnter() {
    if (this.subtask.title) {
      this.onEnterHandler();
    }
  }

  onBackspace() {
    if (this.hasMultipleSubtasks() && !this.subtask.title) {
      this.onBackspaceHandler({ subtask: this.subtask });
      const targetIndex = this.index > 0 ? this.index - 1 : 0;
      this.focus(`subtask-${targetIndex}`);
    }
  }

  removeSubtask() {
    if (this.hasMultipleSubtasks()) {
      this.onRemove({ subtask: this.subtask });
    }
  }

  hasMultipleSubtasks() {
    return this.subtasksCount > 1;
  }
}

export default {
  templateUrl: subtaskFieldUrl,
  controller: SubtaskFieldCtrl,
  controllerAs: 'ctrl',
  bindings: {
    subtask: '<',
    onEnterHandler: '&',
    onBackspaceHandler: '&',
    onRemove: '&',
    isLast: '<',
    subtasksCount: '<',
    index: '<',
  },
};
